export function isPruAgency(clientName) {
  return clientName === "PRUAGENCY" || clientName === "PRUAGENCYMED";
}
export const PRUAGENCY_ENUM = {
  CLIENT_NAME: {
    VOL_LIFE: "vollife",
    PRU_MED: "prumed"
  },
  PRUMED_PLAN: {
    GHS: "Group Hospital & Surgical (GHS) Benefits",
    GMM: "Group Extended Major Medical Rider (GMM) Benefits",
    GADD: "Group Accidental Death & Dismemberment (GADD) Benefits"
  },
  VOLLIFE_PLAN: {
    VTLB: "Group Term Life (TPD up to 65 YO, death benefit)",
    VCCA: "Group Crisis Cover Accelerated (37 Critical illness)",
    VECI: "Group Pre-crisis Guard Accelerated (Early CI)"
  },
  CODE_PLAN: {
    VTLB: "VTLB",
    VCCA: "VCCA",
    VECI: "VECI",
    GHS: "GHS",
    GMM: "GMM",
    GADD: "GADD"
  },
  OPTION_OUT: {
    OUT: "Opt Out"
  },
  DEPENDENT: {
    SPOUSE: "SPOUSE",
    CHILD: "CHILD",
    SPOUSE_CHILDREN: "Spouse & Child(ren)",
    SPOUSE_ONLY: "Spouse Only",
    CHILDREN_ONLY: "Child(ren) Only"
  },
  NAME: {
    NAME: "name"
  }
};
